import React from "react";
import {useLayoutEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom/client';
import reactToWebComponent from "react-to-webcomponent";
import TnWetterBig from "./components/TnWetterBig";
import PropTypes from 'prop-types';
import { Provider } from 'react-redux'
import configureStore from "./store/configureStore";
import styles from './App.css';
const store = configureStore();

const Index = (props) => {
    const lang = props.Lang ? props.Lang : 'de';
    const textcolor = props.Textcolor ? props.Textcolor : '#000';    
    const acclat = props.Acclat;
    const acclon = props.Acclon;
    const accname = props.Accname;
    const berglat = props.Berglat ? props.Berglat : "";
    const berglon = props.Berglon ? props.Berglon : "";
    const bergname = props.Bergname ? props.Bergname : "";
    const bgimage = props.Bgimage ? props.Bgimage : "https://www.tn-wetterwidget.fullmarketing.at/img/bg.jpg";
    const bgimagewinter = props.Bgimagewinter ? props.Bgimagewinter : "";
    const bgopacity = props.Bgopacity ? props.Bgopacity : "";
    const linktextleft = props.Linktextleft ? props.Linktextleft : "";
    const linktitleleft = props.Linktitleleft ? props.Linktitleleft : "";
    const linkurlleft = props.Linkurlleft ? props.Linkurlleft : "";
    const linktextright = props.Linktextright ? props.Linktextright : "";
    const linktitleright = props.Linktitleright ? props.Linktitleright : "";
    const linkurlright = props.Linkurlright ? props.Linkurlright : "";
    const daynumber = props.Daynumber ? props.Daynumber : "5";

    const ref = useRef(null);

    useLayoutEffect(() => {
        const handleResize = (width) => {
            if(ref.current.offsetWidth > 0){
                
                ref.current.classList.remove('content_1499');  
                ref.current.classList.remove('content_1200'); 
                ref.current.classList.remove('content_1024'); 
                ref.current.classList.remove('content_767');
                ref.current.classList.remove('content_520');
                ref.current.classList.remove('content_370');
                
    
                if(ref.current.offsetWidth > 1330){
                    ref.current.classList.add('content_1499');     
                } else if(ref.current.offsetWidth > 1121){
                    ref.current.classList.add('content_1200');                 
                } else if(ref.current.offsetWidth > 945){
                    ref.current.classList.add('content_1024');                 
                } else if(ref.current.offsetWidth > 708){
                    ref.current.classList.add('content_767');                
                } else if(ref.current.offsetWidth > 491){
                    ref.current.classList.add('content_520');                
                } else {
                    ref.current.classList.add('content_370');
                }                
            }
        }
        window.addEventListener('resize', handleResize);
        if(ref.current.offsetWidth > 0){
            handleResize();
        }
    }, []);
    
    return (

        <Provider store={store}>

            <div ref={ref} styles={styles}>

                <TnWetterBig 
                    acclat={acclat}
                    acclon={acclon} 
                    accname={accname}
                    berglat={berglat}
                    berglon={berglon}
                    bergname={bergname}
                    textcolor={textcolor}
                    lang={lang}
                    bgimage={bgimage}
                    bgimagewinter={bgimagewinter}
                    bgopacity={bgopacity}
                    linktextleft={linktextleft}
                    linktitleleft={linktitleleft}
                    linkurlleft={linkurlleft}
                    linktextright={linktextright}
                    linktitleright={linktitleright}
                    linkurlright={linkurlright}
                    daynumber={daynumber}></TnWetterBig>
        
            </div>

        </Provider>

    );
};


Index.propTypes = {
    acclat: PropTypes.string,
    acclon: PropTypes.string,
    accname: PropTypes.string,
    berglat: PropTypes.string,
    berglon: PropTypes.string,
    bergname: PropTypes.string,
    textcolor: PropTypes.string,
    lang: PropTypes.string,
    bgimage: PropTypes.string,
    bgimagewinter: PropTypes.string,
    bgopacity: PropTypes.string,
    linktextleft: PropTypes.string,
    linktitleleft: PropTypes.string,
    linkurlleft: PropTypes.string,
    linktextright: PropTypes.string,
    linktitleright: PropTypes.string,
    linkurlright: PropTypes.string,
    daynumber: PropTypes.string
}


customElements.define(
    "tn-wetter-big",
    reactToWebComponent(Index, React, ReactDOM, {
        props: ["Acclat", "Acclon", "Accname", "Berglat", "Berglon", "Bergname", "Textcolor", "Lang", "Bgimage", "Bgimagewinter", "Bgopacity", "Linktextleft", "Linktitleleft", "Linkurlleft", "Linktextright", "Linktitleright", "Linkurlright", "Daynumber"],
    }),
)